module.exports = __webpack_public_path__ + "img/footer_info.0d5748a0.png";